/**
 * 소셜 로그인 페이지
 * Reference 이미지 디자인 참고
 */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CONFIG from '../config';

const DDALKKAK_LOGIN_URL = 'https://xn--il0b54k.net/auth/login';

function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  // Supabase 세션 확인 → 이미 로그인되어 있으면 /main으로
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(`${CONFIG.CLOUD_FUNCTION_URL}/auth/me`, {
          credentials: 'include',
        });
        const data = await res.json();
        if (data.authenticated) {
          navigate('/main', { replace: true });
        } else {
          // 미로그인 → 딸깍 로그인 페이지로 리다이렉트
          window.location.href = DDALKKAK_LOGIN_URL;
        }
      } catch {
        setIsCheckingAuth(false);
      }
    };
    checkAuth();
  }, [navigate]);

  const handleClose = () => {
    navigate('/');
  };

  // 인증 상태 확인 중이면 로딩 표시
  if (isCheckingAuth) {
    return (
      <div style={containerStyle}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #e5e7eb',
            borderTop: '3px solid #1A62EA',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <style dangerouslySetInnerHTML={{
            __html: `
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `
          }} />
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <h1 style={titleStyle}>{t('login.title')}</h1>

        <div style={buttonsContainerStyle}>
          <button
            onClick={() => { window.location.href = DDALKKAK_LOGIN_URL; }}
            style={{
              width: '100%',
              padding: '14px 24px',
              fontSize: '16px',
              fontWeight: '600',
              color: '#fff',
              backgroundColor: '#4f46e5',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
          >
            {t('login.title')}
          </button>
        </div>

        <div style={termsContainerStyle}>
          <p style={termsTextStyle}>
            {t('login.subtitle')}
            <br />
            <button type="button" style={{...linkStyle, background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}>{t('login.terms')}</button>
            {' | '}
            <button type="button" style={{...linkStyle, background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}>{t('login.privacy')}</button>
          </p>
        </div>

        <button
          onClick={handleClose}
          style={closeButtonStyle}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f3f4f6';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          {t('common.close')}
        </button>
      </div>
    </div>
  );
}

const containerStyle = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#fefefe',
  padding: '20px'
};

const contentStyle = {
  width: '100%',
  maxWidth: '480px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '40px 20px'
};

const titleStyle = {
  fontSize: '32px',
  fontWeight: '700',
  color: '#1a1a1a',
  marginBottom: '40px',
  textAlign: 'center'
};

const buttonsContainerStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '0',
  marginBottom: '30px'
};

const termsContainerStyle = {
  width: '100%',
  marginBottom: '40px'
};

const termsTextStyle = {
  fontSize: '13px',
  lineHeight: '1.6',
  color: '#9ca3af',
  textAlign: 'center',
  margin: 0
};

const linkStyle = {
  color: '#3b82f6',
  textDecoration: 'none',
  fontWeight: '500'
};

const closeButtonStyle = {
  padding: '14px 40px',
  fontSize: '16px',
  fontWeight: '600',
  color: '#6b7280',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};

export default LoginPage;
